import "./App.css";
import { isMobile } from "react-device-detect";
import { MobileApp } from "./Mobile/MobileApp";
import { BrowserApp } from "./Browser/BrowserApp";
import { BrowserRouter } from "react-router-dom";
import { ReactNode } from "react";
import { AuthProvider } from "./common/contexts/authContext";
import { UserProvider } from "./common/contexts/userContext";
import { MatchProvider } from "./common/contexts/fixturesContext";
import { BetProvider } from "./common/contexts/betContext";
import { AllUsersProvider } from "./common/contexts/allUsersContext";
import { TeamFormProvider } from "./common/contexts/teamFormContext";
import { AiCommentaryProvider } from "./common/contexts/aiCommentaryContext";

// Stored-JWT validation now lives in AuthProvider (runs once, before any
// guarded route renders), so App is just the device split + provider stack.
const Providers = ({ children }: { children: ReactNode }) => (
  <BrowserRouter>
    <AuthProvider>
      <UserProvider>
        <MatchProvider>
          <BetProvider>
            <AllUsersProvider>
              <TeamFormProvider>
                <AiCommentaryProvider>{children}</AiCommentaryProvider>
              </TeamFormProvider>
            </AllUsersProvider>
          </BetProvider>
        </MatchProvider>
      </UserProvider>
    </AuthProvider>
  </BrowserRouter>
);

function App() {
  return <Providers>{isMobile ? <MobileApp /> : <BrowserApp />}</Providers>;
}

export default App;
